export default __webpack_public_path__ + "static/media/teeth - active_v1.9d24d7c6.svg";